import React from 'react'
import Button from '@vtex/styleguide/lib/Button'

const ButtonWithIconCapitalize = ({
  id,
  icon,
  noUpperCase,
  onClick,
  testId,
  size,
  variation,
  disabled,
  children,
}: {
  id?: string
  icon?: any
  noUpperCase?: boolean
  onClick?: () => void
  testId?: string
  size?: 'small' | 'regular' | 'large'
  variation?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'inverted-tertiary'
    | 'danger'
    | 'danger-tertiary'
  disabled?: boolean
  children?: any
}) => (
  <Button
    id={id}
    onClick={onClick}
    noUpperCase={noUpperCase}
    size={size}
    testId={testId}
    disabled={disabled}
    variation={variation}
  >
    {icon}
    <span className="pl2">{children}</span>
  </Button>
)

export default ButtonWithIconCapitalize
